import { render, staticRenderFns } from "./MatchByAge.vue?vue&type=template&id=7d46a829&scoped=true&"
import script from "./MatchByAge.vue?vue&type=script&lang=js&"
export * from "./MatchByAge.vue?vue&type=script&lang=js&"
import style0 from "./MatchByAge.vue?vue&type=style&index=0&id=7d46a829&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d46a829",
  null
  
)

export default component.exports